import styles from "./timeclean.module.css";
import { listLocR } from "../../utils/data";
import Status from "../../components/status/status";
import Compoundnew from "../../components/compoundnew/compoundnew";

function TimeClean() {
  return (
    <div className={styles.main}>
      <div className={styles.section_1}>
        <Status
          nameone="Услуги"
          nametwo="Почасовая уборка"
          namethree="Что мы делаем"
          linkone="/clean"
        ></Status>
      </div>
      <div className={styles.section_1}>
        <div className={styles.containerflat}>
          <Compoundnew listloc={listLocR}></Compoundnew>
        </div>
      </div>
    </div>
  );
}

export default TimeClean;
